/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import get from "dlv";
import { useStaticQuery, graphql } from "gatsby";

function SEO({ description, lang, meta, title }) {
  const { siteSettings } = useStaticQuery(
    graphql`
      query {
        siteSettings {
          seoTitle
          openGraphImage
          seoDescription
        }
      }
    `
  );

  const metaTitle = get(siteSettings, "seoTitle");

  const metaDescription = description || get(siteSettings, "seoDescription");
  const ogImage = get(siteSettings, "openGraphImage");

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      titleTemplate={title && `%s | ${metaTitle}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title || metaTitle,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
    >
      <title itemProp="name" lang="en">
        {title || metaTitle}
      </title>

      <script type="text/javascript">
        {`
            if ("www.smbconnect.ru" === window.location.host) {
              (function (m, e, t, r, i, k, a) {
                m[i] =
                  m[i] ||
                  function () {
                    (m[i].a = m[i].a || []).push(arguments);
                  };
                m[i].l = 1 * new Date();
                for (var j = 0; j < document.scripts.length; j++) {
                  if (document.scripts[j].src === r) { 
                    return; 
                  }
                }
                (k = e.createElement(t)),
                  (a = e.getElementsByTagName(t)[0]),
                  (k.async = 1),
                  (k.src = r),
                  a.parentNode.insertBefore(k, a);
              })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
              ym(93059315, "init", {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true
              });
            }
        `}
      </script>
      <noscript>
        {`
            <div>
              <img 
                src="https://mc.yandex.ru/watch/93059315" 
                style="position:absolute; left:-9999px;" 
                alt="" 
              />
            </div>
        `}
      </noscript>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en-GB`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default SEO;
